import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./RegisterClassModal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale';
import { confirm } from 'util/confirm';

const localeCN = {
  id: "ResgisterOnPosterModal",
  code: "CN",
  text: {
    "Are you sure you want to close?": "你确认关闭吗？",
  },
}

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		return (
      <Modal
        className='register-on-poster-modal'
        isShowingModal={show} // if you want to show it when component mounts, set it true
        allowCloseByClickingShadow={false}

        // useDefaultClosebutton={true}
        // fixedHeight={300}
        // fixedWidth={300}
        // overlayColor="#11151E"
        // contentHeight={300}
        overlayOpacity={0.25}

        hasHeader={true}
        headerType="bold" // default, bold
        headerTitle={__('Register', locale)}
        headerIcon="fa icon-ticket" // class for icon tag
        // headerClassName=""
        // headerCustomContent={}

        // hasFooter={true}
        // footerType="bold" // grey, transparent, bold
        // footerClassName=""
        // footerCustomContent={}
        onCloseModalClick={()=>{
          confirm(__('Are you sure you want to close?', localeCN))
          .then(() => {
            dismiss();
          })
          .catch((err) => {})
        }}
      >
        <ModalContent {...this.props}/>
      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/ModalBody.js